export default __webpack_public_path__ + "static/media/m-bg-world.3789033b.png";